/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Release_Intro_Chip_TourInputs */



/**
* | output |
* | --- |
* | "Walk me through the new features" |
*
* @param {Uno_Release_Intro_Chip_TourInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_release_intro_chip_tour = /** @type {((inputs?: Uno_Release_Intro_Chip_TourInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Release_Intro_Chip_TourInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeig mir die neuen Funktionen")
	return /** @type {LocalizedString} */ ("Walk me through the new features")
});